module.exports = __webpack_public_path__ + "img/cute-husky-puppy-yawning.cd8a580c.png";